import React, { useEffect, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import MainFooter from '../Components/footer/MainFooter'
import ProfileWidgetPersonal from "../Components/widgets/ProfileWidgetPersonal";
import ProfileWidgetPayments from "../Components/widgets/ProfileWidgetPayments";
import ProfileWidgetOnsite from "../Components/widgets/ProfileWidgetOnsite";
import ProfileWidgetAnniste from "../Components/widgets/ProfileWidgetAnniste";
import { FaCalendarDay, FaCreditCard, FaMapPin, FaPowerOff, FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logout } from '../reduxAuth/authSlice';
import { Helmet } from 'react-helmet';

function ProfileScreen() {
      
  // State to manage which widget is currently active
  const [activeWidget, setActiveWidget]                               = useState('profileWidgetPersonal');

  const {user}                                                        = useSelector((state) => state.auth);
  const navigate                                                      = useNavigate();
  const dispatch                                                      = useDispatch();

  const onLogOut = () => {
      dispatch(logout());
      navigate("/");
  }

  useEffect(() => {
   
    if(!user) {
      navigate('/access-denied');
    }
  },[])
  
  // Function to render the active widget component
  const renderWidget = () => {
      switch (activeWidget) {
        case 'profileWidgetPersonal':
          return <ProfileWidgetPersonal user={user} />;
        case 'profileWidgetPayments':
          return <ProfileWidgetPayments user={user} />;
        case 'profileWidgetOnsite':
          return <ProfileWidgetOnsite user={user} />;
        case 'profileWidgetAnniste':
          return <ProfileWidgetAnniste user={user} />;
        default:
          return <ProfileWidgetPersonal user={user}/>;
      }
  };


  return (
    <div className="main-layer">
      <Helmet>
              <title>Lovedripp - Profile </title>
      </Helmet>
        <TopNavigation title={"Profile"} classBack="full-white"/>
        <div className="content-layer">

            <div className="row g-0 h-100 profile-container creamyback section-item ">
              {/* Sidebar Column */}
              <aside className="col-12 col-md-4 col-lg-3 sidebar-custom p-4 d-flex flex-column rounded-start-3">
                <div className="mb-4 text-center text-md-start">
                  <h1 className="display-6 fw-bold">Profile</h1>
                  <p className="lead text-light-emphasis">Manage your account</p>
                </div>

                <nav className="nav flex-column nav-pills flex-grow-1">
                  {/* Sidebar Navigation Item: Personal Details */}
                  <button
                    onClick={() => setActiveWidget('profileWidgetPersonal')}
                    className={`nav-link text-start mb-2 rounded-3 sidebar-btn ${activeWidget === 'profileWidgetPersonal' ? 'active' : ''}`}
                  >
                    <span className="prof-icon">
                    <FaUser/>
                    </span>
                    <span className="prof-line">
                    Personal Details
                    </span>
                  </button>

                  {/* Sidebar Navigation Item: Transactions */}
                  <button
                    onClick={() => setActiveWidget('profileWidgetPayments')}
                    className={`nav-link text-start mb-2 rounded-3 sidebar-btn ${activeWidget === 'profileWidgetPayments' ? 'active' : ''}`}
                  >
                    
                    <span className="prof-icon">
                      <FaCreditCard />
                    </span>
                    <span className="prof-line">
                      Transactions
                    </span>
                  </button>

                  {/* Sidebar Navigation Item: Onsites */}
                  <button
                    onClick={() => setActiveWidget('profileWidgetOnsite')}
                    className={`nav-link text-start mb-2 rounded-3 sidebar-btn ${activeWidget === 'profileWidgetOnsite' ? 'active' : ''}`}
                  >
                    <span className="prof-icon">
                      <FaMapPin />
                    </span>
                    <span className="prof-line">
                      Onsites
                    </span>
                  </button>

                  {/* Sidebar Navigation Item: Annisites 
                  <button
                    onClick={() => setActiveWidget('profileWidgetAnniste')}
                    className={`nav-link text-start mb-2 rounded-3 sidebar-btn ${activeWidget === 'profileWidgetAnniste' ? 'active' : ''}`}
                  >
                    <span className="prof-icon">
                      <FaCalendarDay />
                    </span>
                    <span className="prof-line">
                      Annisites
                    </span>
                  </button>
                  */}
                  {/* Sidebar Navigation Item: Annisites */}
                  <button
                    onClick={() => onLogOut()}
                    className={`nav-link text-start mb-2 rounded-3 sidebar-btn`}
                  >
                    <span className="prof-icon">
                      <FaPowerOff />
                    </span>
                    <span className="prof-line">
                      Logout
                    </span>
                  </button>
                </nav>
              </aside>

              {/* Content Area for Widgets */}
              <main className="col-12 col-md-8 col-lg-9 p-4 main-content-custom d-flex flex-column rounded-end-3">
                {renderWidget()}
              </main>
            </div>


        </div>
        <MainFooter />
    </div>
  )
}

export default ProfileScreen;